import { Box, MenuItem, Slider, Stack, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlPermissions, GqlProtocolVisit } from "~/__generated__";
import useHasTenantPermission from "~/modules/auth/hooks/useHasPermission";

import {
    ProtocolVisitCondition,
    VisitConditionAfterVisit,
    VisitConditionBeforeVisit,
} from "../../types/ProtocolVisitCondition";

type Props = {
    allVisits: GqlProtocolVisit[];
    condition: VisitConditionAfterVisit | VisitConditionBeforeVisit;
    onChange: (condition?: ProtocolVisitCondition) => void;
};

export default function ConditionEditorOtherVisit({ allVisits, condition, onChange }: Props) {
    const { t } = useTranslation("protocol");
    const isAdmin = useHasTenantPermission(GqlPermissions.Administrator);

    return (
        <Box sx={{ display: "flex", gap: 1 }}>
            <Box sx={{ width: "96px" }}>
                <TextField
                    select
                    disabled={!isAdmin}
                    label={t("protocolVisitConditionsEditor.selectVisit")}
                    value={condition.visitId || "empty"}
                    onChange={e =>
                        onChange({
                            ...condition,
                            visitId: e.target.value != "empty" ? e.target.value : undefined,
                        })
                    }
                >
                    <MenuItem value="empty">{t("protocolVisitConditionsEditor.selectVisitEmpty")}</MenuItem>
                    {allVisits.map(visit => (
                        <MenuItem key={visit.id} value={visit.id}>
                            #{visit.number}
                        </MenuItem>
                    ))}
                </TextField>
            </Box>
            <Box sx={{ flex: 1 }}>
                <Stack direction="row" gap={1} sx={{ height: "48px", alignItems: "end" }}>
                    <Typography
                        align="right"
                        sx={{
                            height: "48px",
                            flex: 1,
                            xs: { display: "none" },
                        }}
                    >
                        {t("protocolVisitConditionsEditor.waitDays")}
                    </Typography>
                    <Slider
                        sx={{ mx: 2 }}
                        disabled={!isAdmin}
                        value={condition.minDaysBetween ?? 0}
                        min={0}
                        max={80}
                        step={1}
                        shiftStep={10}
                        valueLabelDisplay="on"
                        onChange={(_, value) => {
                            if (typeof value === "number") {
                                onChange({
                                    ...condition,
                                    minDaysBetween: value,
                                });
                            }
                        }}
                    />
                </Stack>
            </Box>
        </Box>
    );
}
